
















































































































































































import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class TalkmateIntro extends Vue {
  // 领导关怀
  leadershipList = [
    {
      photo: require('../../assets/images/about/pic-1-1.png'),
      text: 'about.talkmateIntro.text35'
    },
    {
      photo: require('../../assets/images/about/pic-1-2.png'),
      text: 'about.talkmateIntro.text36'
    },
    {
      photo: require('../../assets/images/about/pic-1-3.png'),
      text: 'about.talkmateIntro.text37'
    },
    {
      photo: require('../../assets/images/about/pic-1-4.png'),
      text: 'about.talkmateIntro.text38'
    },
    {
      photo: require('../../assets/images/about/pic-1-5.png'),
      text: 'about.talkmateIntro.text39'
    },
    {
      photo: require('../../assets/images/about/pic-1-6.png'),
      text: 'about.talkmateIntro.text40'
    },
    {
      photo: require('../../assets/images/about/pic-1-7.png'),
      text: 'about.talkmateIntro.text41'
    },
    {
      photo: require('../../assets/images/about/pic-1-8.png'),
      text: 'about.talkmateIntro.text42'
    },
    {
      photo: require('../../assets/images/about/pic-1-9.png'),
      text: 'about.talkmateIntro.text43'
    }
  ]
  // 汇聚力量
  convergeList = [
    {
      photo: require('../../assets/images/about/pic-2-1.png'),
      text: 'about.talkmateIntro.text45'
    },
    {
      photo: require('../../assets/images/about/pic-2-2.png'),
      text: 'about.talkmateIntro.text46'
    },
    {
      photo: require('../../assets/images/about/pic-2-3.png'),
      text: 'about.talkmateIntro.text47'
    },
    {
      photo: require('../../assets/images/about/pic-2-4.png'),
      text: 'about.talkmateIntro.text48'
    },
    {
      photo: require('../../assets/images/about/pic-2-6.png'),
      text: 'about.talkmateIntro.text49'
    },
    {
      photo: require('../../assets/images/about/pic-2-5.png'),
      text: 'about.talkmateIntro.text50'
    },
    {
      photo: require('../../assets/images/about/pic-2-7.png'),
      text: 'about.talkmateIntro.text51'
    },
    {
      photo: require('../../assets/images/about/pic-2-8.png'),
      text: 'about.talkmateIntro.text52'
    },
    {
      photo: require('../../assets/images/about/pic-2-9.png'),
      text: 'about.talkmateIntro.text53'
    },
    {
      photo: require('../../assets/images/about/pic-2-10.png'),
      text: 'about.talkmateIntro.text54'
    }
  ]
  // 历史时刻
  historyList= [
    {
      photo: require('../../assets/images/about/pic-3-1.png'),
      text: 'about.talkmateIntro.text56'
    },
    {
      photo: require('../../assets/images/about/pic-3-2.png'),
      text: 'about.talkmateIntro.text57'
    },
    {
      photo: require('../../assets/images/about/pic-3-3.png'),
      text: 'about.talkmateIntro.text58'
    },
    {
      photo: require('../../assets/images/about/pic-3-4.png'),
      text: 'about.talkmateIntro.text59'
    },
    {
      photo: require('../../assets/images/about/pic-3-5.png'),
      text: 'about.talkmateIntro.text60'
    },
    {
      photo: require('../../assets/images/about/pic-3-6.png'),
      text: 'about.talkmateIntro.text61'
    },
    {
      photo: require('../../assets/images/about/pic-3-7.png'),
      text: 'about.talkmateIntro.text62'
    }
  ]
  mounted () {
    this.aboutSwiperInit()
  }
  // 轮播
  aboutSwiperInit () {
    /* eslint-disable */
    this.$nextTick(() => {
      new Swiper('.swiper-container1', {
        direction: 'horizontal',
        speed: 500,
        loop: true,
        slidesPerView: 'auto',
        paginationClickable: true,
        prevButton: '.swiper-button-prev1',
        nextButton: '.swiper-button-next1'
        // direction: 'horizontal',
        // loop: true,
        // autoplay: false,
        // speed: 1000,
        // slidesPerView: 'auto',
        // navigation: {
        //   prevEl: '.swiper-button-prev1',
        //   nextEl: '.swiper-button-next1'
        // }
      })
      new Swiper('.swiper-container2', {
        direction: 'horizontal',
        speed: 500,
        loop: true,
        slidesPerView: 'auto',
        paginationClickable: true,
        prevButton: '.swiper-button-prev2',
        nextButton: '.swiper-button-next2'
        // direction: 'horizontal',
        // loop: true,
        // autoplay: false,
        // speed: 1000,
        // slidesPerView: 'auto',
        // navigation: {
        //   prevEl: '.swiper-button-prev2',
        //   nextEl: '.swiper-button-next2'
        // }
      })
      new Swiper('.swiper-container3', {
        direction: 'horizontal',
        speed: 500,
        loop: true,
        slidesPerView: 'auto',
        paginationClickable: true,
        prevButton: '.swiper-button-prev3',
        nextButton: '.swiper-button-next3'
        // direction: 'horizontal',
        // loop: true,
        // autoplay: false,
        // speed: 1000,
        // slidesPerView: 'auto',
        // navigation: {
        //   prevEl: '.swiper-button-prev3',
        //   nextEl: '.swiper-button-next3'
        // }
      })
    })
    /* eslint-enable */
  }
}
